import Cookies from "universal-cookie";
import { cookiesKeyNames } from "@revbox/common-fe";
import { statusLabels } from "@revbox/localization";
import { getPathKey } from "../../../../../contexts/CookiesContext";

const getLanguage = () => {
  const cookies = new Cookies();
  const pathKey = getPathKey();
  return cookies.get(pathKey)?.[cookiesKeyNames.language]?.value || 'EN';
};

export const createClusterClasses = (params) => {
  const nameParts = params.data.name.split('@');
  const statusParts = params.data.status.split('@');
  const actionParts = params.data.action.split('@');
  const positionParts = params.data.position.split('@');

  const language = getLanguage();
  const status = statusParts[0];
  const [pos, , bid] = positionParts;
  const views = nameParts[1];
  const level = nameParts[2];
  const categoryMatch = nameParts[6];

  return {
    // Cluster Level
    'cluster-1 cluster-1-row-tour': level === '1',
    'cluster-2 cluster-2-row-tour': level === '2',
    'cluster-3 cluster-3-row-tour': level === '3',

    // Cluster Category Match
    'cluster-category-match': categoryMatch === 'true',

    // Cluster Status
    'cluster-active': status === statusLabels[language]["Active"],
    'cluster-inactive': status === statusLabels[language]["Inactive"],
    'cluster-paused': status === statusLabels[language]["Paused"],
    'cluster-inherited': status === statusLabels[language]["Inherited"],

    // Cluster Action
    'cluster-biddable': actionParts[3] === 'false',
    'cluster-locked': actionParts[3] === 'false' || views === '0',

    // Cluster Position
    'cluster-position-shown': pos !== '99' && Number(bid) >= Number(pos),
    'cluster-position-not-shown': pos === '99' || Number(bid) < Number(pos),

    // Cluster Views
    'cluster-no-views': views === '0',
  };
};
